import React from 'react';
import { useQuery } from 'react-query';
import CandleStick from './candlestick';
import { fetchWithAppCheck } from '../../api/fetchWithAppCheck';

const API_BASE = "https://getstockdata-pyhsltxciq-uc.a.run.app/getStockData";

const fetchStockData = async (symbol) => {
  // const res = await fetch(`${API_BASE}?symbol=${symbol}&limit=2000`);
  const res = await fetchWithAppCheck(`${API_BASE}?symbol=${symbol}&limit=2000`);
  const json = await res.json();
  return json.results || [];
};

const Stocks = ({ selectedTicker, match }) => {
  const getSymbol = () => {
    let { dataId } = match.params;
    if (!dataId) dataId = selectedTicker;
    return dataId || "AAPL";
  };

  const symbol = getSymbol();

  const { data = [], isLoading } = useQuery(
    ['stock', symbol],
    () => fetchStockData(symbol),
    {
      staleTime: 5 * 60 * 1000,
      cacheTime: 10 * 60 * 1000,
      refetchOnWindowFocus: false
    }
  );

  return (
    <div className="container-fluid" role="main">
      <h1>Stocks</h1>
      {/* <p>Select a stock symbol.</p> */}

      {isLoading && <div>Loading...</div>}

      <CandleStick symbol={symbol} data={data} />
    </div>
  );
};

export default Stocks;